import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function TractionSection() {
  return <Section background="ivory" className="border-y border-purple-200 bg-purple-50" data-id="element-421" data-mp="2f3si48wrbdvx">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-422" data-mp="21cvnkcj9smm8">
        <div data-id="element-423" data-mp="269vyp1uz8fk7">
          <FadeIn data-id="element-424" data-mp="26bgs2o5k1sgh">
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-425" data-mp="26ax9d582z01e">
              Early Validation, <br data-id="element-426" data-mp="2u11b171pkppr" />
              <span className="italic text-charcoal/60" data-id="element-427" data-mp="2tyf5fcydoka6">Strong Signal</span>
            </h2>
            <p className="text-lg text-charcoal/70 mb-8" data-id="element-428" data-mp="2xzqvtkp2t9jf">
              Early-stage, but highly validated with strong ecosystem pull. The
              market is ready for a new standard of care.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-8" data-id="element-429" data-mp="18mngpgu6pomy">
          <FadeIn delay={100} data-id="element-430" data-mp="18p9nhe994044">
            <div className="bg-ivory/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-white/50" data-id="element-431" data-mp="1dmjayod2y1pb">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-432" data-mp="swkovo65bbpf">
                $37K
              </div>
              <div className="text-sm text-charcoal/60 font-medium" data-id="element-433" data-mp="ox2e3l81gh0b">
                Non-dilutive funding
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={200} data-id="element-434" data-mp="xwp9nqe36slg">
            <div className="bg-ivory/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-white/50" data-id="element-435" data-mp="xvnvve5ors01">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-436" data-mp="1buvuo5xxsy3p">
                20+
              </div>
              <div className="text-sm text-charcoal/60 font-medium" data-id="element-437" data-mp="17sitluu4xod9">
                Practitioners onboarded
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={300} data-id="element-438" data-mp="1gnykq43i9pf5">
            <div className="bg-ivory/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-white/50" data-id="element-439" data-mp="1gp04qy2i1m90">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-440" data-mp="1vi3923r2y3hs">
                250+
              </div>
              <div className="text-sm text-charcoal/60 font-medium" data-id="element-441" data-mp="1xokvwlxors99">
                Waitlist users
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={400} data-id="element-442" data-mp="22nnov80e680v">
            <div className="bg-ivory/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-white/50" data-id="element-443" data-mp="27mh53872cd4q">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-444" data-mp="2ccxgynv8jqoz">
                50+
              </div>
              <div className="text-sm text-charcoal/60 font-medium" data-id="element-445" data-mp="2hd1x2cs8ejeo">
                Engaged early members
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>;
}